import classNames from 'classnames';
import { MAX_ITEM_UPGRADE_LEVEL } from '@sorrem/shared';
import styles from './UpgradePips.module.scss';

interface UpgradePipsProps {
    /** How many pips are filled: the item's upgrade level, or a level it could reach. */
    readonly level: number;
    /** Sizes the pips through `--upgrade-pip-size`; positioning is up to the parent. */
    readonly className?: string;
}

/** An item's upgrade level as a row of diamond pips, one per level up to the cap, filled to its level (#287). */
export function UpgradePips({ level, className }: UpgradePipsProps): JSX.Element {
    return (
        <span className={classNames(styles.upgradePips, className)} role='img' aria-label={`Upgrade level ${level} of ${MAX_ITEM_UPGRADE_LEVEL}`}>
            {Array.from({ length: MAX_ITEM_UPGRADE_LEVEL }, (_, pip) => (
                <span key={pip} className={classNames(styles.pip, pip < level && styles.filled)} />
            ))}
        </span>
    );
}
